import { createSelector } from '@ngrx/store';
import { AppState } from '../index';
import { ConfigState } from './config.reducer';

export const $configState = (state: AppState): ConfigState => state.config;

export const $supportEmail = createSelector(
    $configState,
    state => state.supportEmail,
);
